import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import {ReactComponent as WrapArrow} from '../../assets/wrap-arrow.svg';
// import WrapArrow from '../../assets/wrap-arrow.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getImage } from '../../redux/staticSlice';
import { VideoPlayer } from '../VideoPlayer';

const getTitleByStaticType = (type) => {
    switch (type) {
        case 'bso': return 'Фотография БСО';
        case 'cheque': return 'Фотография чека';
        case 'userDoc': return 'Фотография пользователя';
        case 'promDoc': return 'Фотография промоутера';
        default: return 'Неизвестный тип файла';
    }
}

export const StaticPopup = ({ closeFn, getTitle, contentType = 'photos', content, deleteAccess, deleteFunc }) => {
    const outsideClickHandler = (evt) => {
        evt.target === evt.currentTarget && closeFn();
    };
    if (!content.length) {
        return null;
    }
    const staticStorage = useSelector((state) => state.static);
    const imageStorage = staticStorage.photos.map(el => ({...el, staticType: 'photo'}));
    const videoStorage = staticStorage.videos.map(el => ({...el, staticType: 'video'}));

    const contentStorage = contentType === 'merged' ? [...imageStorage, ...videoStorage]
    : staticStorage[contentType].map(el => ({...el, contentType}))
    
    const dispatch = useDispatch();
    const [fileIndex, setFileIndex] = useState(0);

    const thisFile = contentStorage.find(file => file.name === content[fileIndex].fileName && file.type === content[fileIndex].type);
    const isPhoto = content[fileIndex].isPhoto;
    const isPhotoLoaded = !!thisFile;   //с видео thisFile не получаем
    
    useEffect(() => {
        content.forEach(file => {
            if (file.isPhoto) {
                dispatch(getImage({type: file.type, name: file.fileName}));
            }
        })
    }, [content]);

    const deleteElementHandler = () => {
        fileIndex && setFileIndex(prev => prev - 1);
        deleteFunc(content[fileIndex].type, content[fileIndex].fileName);
    }

    const isNavEnabled = content.length > 1;
    const switchContentHandler = (nextDir) => {
        if (!isNavEnabled) return;
        if (nextDir) {
            if (fileIndex+1 > content.length-1) {
                setFileIndex(0);
                return;
            }
            setFileIndex(fileIndex+1);
            return;
        }
        if (fileIndex === 0) {
            setFileIndex(content.length-1);
            return;
        }
        setFileIndex(fileIndex-1);
    }
    const contentTitle = getTitle ? getTitle(content[fileIndex]) : getTitleByStaticType(content[fileIndex].type);

    const staticElement = isPhoto ? !isPhotoLoaded ? <div>Загрузка..</div> : <img src={thisFile.src} alt="" /> : <VideoPlayer type={content[fileIndex].type} name={content[fileIndex].fileName} />
    return createPortal(
        <div className="popup-wrapper" onMouseDown={outsideClickHandler}>
            <div className="image-popup">
                <div className="image-popup__image">
                    <div className={`image-popup__nav prev ${isNavEnabled ? 'enabled' : ''}`} onClick={() => switchContentHandler(false)}><WrapArrow width={20} height={20}/></div>
                    <div className={`image-popup__nav next ${isNavEnabled ? 'enabled' : ''}`} onClick={() => switchContentHandler(true)}><WrapArrow width={20} height={20}/></div>
                    {staticElement}
                </div>
                <div className="image-popup__footer">
                    <div className="image-popup__info">
                        <span>{contentTitle}</span>
                        <span>[{fileIndex+1}/{content.length}]</span>
                    </div>
                    {deleteAccess && <span className='image-popup__delete' onClick={deleteElementHandler}>Удалить</span>}
                </div>
            </div>
        </div>,
        document.getElementById('popup-root'),
    );
};
